import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const Dashboard = lazy(() => import('../../pages/dashboard/Dashboard'));
const Profile = lazy(() => import('../../pages/user/profile/Profile'));
const BuddyList = lazy(() => import('../../pages/buddies/BuddyList'));

export const DashboardRouteImport = {
    RoutesMap,
    Dashboard,
    Profile,
    BuddyList,
}